import React from 'react';
import Axios from 'axios';
import Config from '../Config.json';

import GameData from '../Components/GameData';
import GamePresentation from '../Components/GamePresentation';

//mise en page marine
const styles = {
  page: { maxWidth: 860, margin: '40px auto', padding: '0 16px', lineHeight: 1.7, fontSize: 16 },
  switchBar: {
    display: 'flex', justifyContent: 'center', gap: 12,
    padding: '10px 14px', background: '#f6f7f9',
    border: '1px solid #e5e7eb', borderRadius: 12, marginBottom: 24
  },
  linkPill: {
    display: 'inline-block', padding: '8px 14px', borderRadius: 9999,
    border: '1px solid #d1d5db', textDecoration: 'none', color: '#111827'
  },
  h1: { fontSize: 28, lineHeight: 1.25, margin: '0 0 8px 0' },
  meta: { fontSize: 13, color: '#6b7280', margin: '0 0 24px 0' },
  h2: { fontSize: 20, margin: '28px 0 8px 0' },
  ul: { paddingLeft: 22, margin: '8px 0 16px 0' },
};
//fin

const game = [];

class PolicyPage extends React.Component {
  state = {
    game
  }

  async componentDidMount() {
    const gameRes = await Axios({
      method: 'GET',
      url: Config.strapi.protocol + '://' + Config.strapi.address + ':' + Config.strapi.port + '/games?name=' + Config.website.name
    })

    const game = gameRes.data
    this.setState({ game })
  }

  render() {
    const { game } = this.state

    if (game[0] !== undefined) {
      const gamedata = game[0];
      return (
        <div style={styles.page}>
          {/* Barre de switch / lien sous l'en-tete */}
          <div style={styles.switchBar} role="navigation" aria-label="Legal pages">
            <a href="/eula" style={styles.linkPill}>End-user license agreement</a>
            <a href="/policy" style={styles.linkPill}>Privacy policy</a>
          </div>

          <h1 style={styles.h1}>DARK HOURS - PRIVACY POLICY</h1>
          <p style={styles.meta}><strong><em>Last updated: January 22, 2026</em></strong></p>
          <p><strong>Piece of Cake Studios, S.A.S. (Paris, France)</strong></p>

          <h2 style={styles.h2}>1. Who we are</h2>
          <p>
            Piece of Cake Studios, S.A.S. ("Piece of Cake", "we", "us") develops and publishes the game Dark Hours (the "Game").
            This Privacy Policy explains how we process information when you play the Game or use related services (for example online multiplayer or customer support).
          </p>
          <p>
            If you play on a third-party platform (for example PlayStation, Xbox, Steam, or Epic), that platform also processes data about you under its own privacy policy.
            We only process the data we need to operate and improve the Game.
          </p>

          <h2 style={styles.h2}>2. What we process</h2>
          <p>Depending on your platform, region, and enabled features, we may process the following categories of information:</p>

          <p><strong>A) Platform identifiers (online play and entitlements)</strong></p>
          <ul style={styles.ul}>
            <li>Platform user identifiers needed to provide online features (for example platform account ID, online ID, gamertag, user ID, or similar identifiers provided by the platform or our online services).</li>
            <li>Matchmaking/session identifiers and party information required for multiplayer and cross-play.</li>
            <li>Entitlement or ownership signals (to confirm access to the Game or content).</li>
          </ul>

          <p><strong>B) Gameplay and game telemetry</strong></p>
          <ul style={styles.ul}>
            <li>In-game actions and progress, match results, and gameplay statistics (for balancing, debugging, and improving the Game).</li>
            <li>Session information (for example session duration).</li>
          </ul>

          <p><strong>C) Device, network, and technical logs</strong></p>
          <ul style={styles.ul}>
            <li>IP address and network diagnostics (typically required for online connectivity and security).</li>
            <li>Device/console type, operating system version, language/region settings.</li>
            <li>Crash reports, error logs, and performance data to fix bugs and improve stability.</li>
          </ul>

          <p><strong>D) Voice communications (if enabled)</strong></p>
          <ul style={styles.ul}>
            <li>The Game may include in-game voice chat. Audio may be processed in real time to provide the voice feature.</li>
            <li>We do not intentionally store or record voice communications, unless a specific feature explicitly states otherwise.</li>
            <li>There is no in-game text chat feature.</li>
          </ul>

          <p><strong>E) Customer support</strong></p>
          <ul style={styles.ul}>
            <li>If you contact us, we process the information you provide (for example your email address, message content, and attachments/logs you choose to send).</li>
          </ul>

          <p><strong>No payment data</strong></p>
          <p>
            Purchases (if any) are handled by the platform store (Steam/Epic/PlayStation Store/Microsoft Store). We do not receive your full payment details from the platform.
          </p>

          <h2 style={styles.h2}>3. How we use information</h2>
          <ul style={styles.ul}>
            <li>To provide and operate the Game, including online multiplayer and cross-play.</li>
            <li>To maintain security, prevent fraud and cheating, and enforce rules.</li>
            <li>To diagnose bugs, improve performance, and develop new features.</li>
            <li>To provide customer support and respond to requests.</li>
            <li>To comply with legal obligations.</li>
          </ul>

          <h2 style={styles.h2}>4. Legal bases (EEA/UK)</h2>
          <p>Where GDPR/UK GDPR applies, we rely on:</p>
          <ul style={styles.ul}>
            <li>Contract performance (providing the Game and online features).</li>
            <li>Legitimate interests (security, anti-cheat, preventing abuse, improving stability and user experience).</li>
            <li>Legal obligations (where applicable).</li>
            <li>Consent (only where required for a specific optional feature or processing activity).</li>
          </ul>

          <h2 style={styles.h2}>5. Sharing of information</h2>
          <p>We do not sell your personal information.</p>
          <p>We may share information with:</p>
          <ul style={styles.ul}>
            <li><strong>Platform providers</strong> (for example Sony/PlayStation, Microsoft/Xbox, Valve/Steam, Epic) for distribution, authentication, entitlements, and platform services.</li>
            <li><strong>Service providers</strong> that help us operate the Game (for example hosting, matchmaking, crash reporting, customer support tools). They act under contract and only process data for our instructions.</li>
            <li><strong>Legal and safety</strong>: authorities or third parties when required by law or to protect rights, safety, and security.</li>
          </ul>
          <p>
            We do not share platform-provided user data with advertising networks, data brokers, or for personalized advertising.
          </p>

          <h2 style={styles.h2}>6. Data storage, location, and transfers</h2>
          <p>
            We use industry-standard safeguards to protect information. We aim to store and process data primarily in the EU when feasible.
            Some service providers may process data outside the EU/EEA/UK; when required, we use appropriate safeguards for international transfers.
          </p>

          <h2 style={styles.h2}>7. Data retention</h2>
          <p>We keep information only as long as necessary for the purposes described:</p>
          <ul style={styles.ul}>
            <li>Technical logs and crash reports: retained for troubleshooting and stability, then deleted or aggregated.</li>
            <li>Online identifiers and session data: retained as needed to operate multiplayer/cross-play and for security/abuse prevention.</li>
            <li>Support communications: retained for handling your request and follow-up, then deleted or archived according to internal retention schedules.</li>
          </ul>

          <h2 style={styles.h2}>8. Security</h2>
          <p>
            We use technical and organizational measures designed to protect information (for example access controls, least privilege, and security monitoring).
            No system is 100% secure, but we work to protect data against unauthorized access.
          </p>

          <h2 style={styles.h2}>9. Children's privacy</h2>
          <p>
            The Game is not intended for children under 13 (or the equivalent minimum age in your country). If we learn we collected personal information from a child below the applicable minimum age,
            we will delete it.
          </p>

          <h2 style={styles.h2}>10. Your rights</h2>
          <p>
            Depending on where you live (for example EU/UK under GDPR, California under CCPA/CPRA, and other jurisdictions), you may have rights to access, correct, delete,
            or object to certain processing, and to withdraw consent where applicable.
          </p>
          <p>
            To exercise these rights, contact us at <a href="mailto:contact@pieceofcake-studios.com">contact@pieceofcake-studios.com</a>.
          </p>
          <p>
            Platform note: if you play on PlayStation/Xbox/Steam/Epic, some data is controlled by the platform. You may need to use the platform's privacy settings/tools for certain requests.
          </p>

          <h2 style={styles.h2}>11. Changes to this policy</h2>
          <p>
            We may update this Privacy Policy from time to time. If changes are material, we will notify you through the Game, our website, or the relevant store listing.
          </p>

          <h2 style={styles.h2}>12. Contact</h2>
          <p>
            If you have questions about this Privacy Policy, contact us at <a href="mailto:contact@pieceofcake-studios.com">contact@pieceofcake-studios.com</a>.
          </p>

        </div>
      );

    } else {
      return (
        <div>
          Game not found. There was a problem with the database.
        </div>
      );
    }
  }
}

export default PolicyPage;
